import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { StyledSliderThumb, SliderLabel, Slider, StyledSliderTrack, token } from "@zillow/constellation";
import { getWholeDollars } from "../../utils/zhl-calculator.esm.js";
import { debounce } from "lodash";
import { handleFieldChangeEvent } from "./DTICalculator.clickstream.esm.js";
const StyledSlider = styled(Slider).withConfig({
  displayName: "DTISlider__StyledSlider",
  componentId: "sc-1dsrlzi-0"
})(["", "{height:8px;}", ":nth-child(1){background-color:", ";}", ":nth-child(2){background-color:", ";}", ":nth-child(3){background-color:", ";}", "{visibility:hidden;}", " ~ ", "{visibility:visible;top:2px;}"], StyledSliderTrack, StyledSliderTrack, token("colors.orange500"), StyledSliderTrack, token("colors.blue600"), StyledSliderTrack, token("colors.brand"), StyledSliderThumb, StyledSliderThumb, StyledSliderThumb);
const DTISlider = ({
  monthlyIncome,
  debtsOut,
  mortgagePayment,
  inputValue,
  onSliderChange
}) => {
  const onSliderChangeDebounced = useMemo(() => debounce((value) => {
    onSliderChange(value);
    handleFieldChangeEvent("Debt slider", "slider");
  }, 50), [onSliderChange]);
  return /* @__PURE__ */ jsx(
    StyledSlider,
    {
      withTracks: true,
      max: monthlyIncome,
      value: [debtsOut, mortgagePayment + debtsOut],
      onChange: onSliderChangeDebounced,
      snapDragDisabled: true,
      step: 10,
      ariaLabel: "total monthly payment",
      ariaValuetext: `$${inputValue} per month`,
      renderThumb: (thumbProps) => /* @__PURE__ */ jsx(StyledSliderThumb, { ...thumbProps, children: /* @__PURE__ */ jsx(SliderLabel, { style: {
        display: "inline-flex",
        width: "max-content",
        top: "-55px",
        padding: "8px"
      }, id: thumbProps.key, children: "$" + getWholeDollars(inputValue) + "/mo" }) })
    }
  );
};
DTISlider.propTypes = {
  monthlyIncome: PropTypes.number,
  debtsOut: PropTypes.number,
  mortgagePayment: PropTypes.number,
  inputValue: PropTypes.number,
  onSliderChange: PropTypes.func.isRequired
};
export {
  DTISlider as default
};
